"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var PlayerDetailsModal_1 = __importDefault(require("./PlayerDetailsModal"));
var react_i18next_1 = require("react-i18next");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var AddPresentationModal_1 = __importDefault(require("./AddPresentationModal"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ResourceAccessModal_1 = __importDefault(require("../common/ResourceAccessModal"));
var types_1 = require("@/Types/types");
var PlayerDeleteErrorModal_1 = __importDefault(require("./PlayerDeleteErrorModal"));
var AddEventModal_1 = __importDefault(require("./AddEventModal"));
var AddMetadataModal_1 = __importDefault(require("./AddMetadataModal"));
var PlayersListView_1 = __importDefault(require("./PlayersListView"));
var PlayersOverviewList_1 = __importDefault(require("./PlayersOverviewList"));
var PlayersListBase = function (props) {
    var playerGroups = props.playerGroups, refreshPlayerGroups = props.refreshPlayerGroups, permissions = props.permissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var unselect = (0, react_admin_1.useUnselect)("players");
    var refresh = (0, react_admin_1.useRefresh)();
    var _a = (0, react_1.useState)(false), playerDetailsModalShown = _a[0], setPlayerDetailsModalShown = _a[1];
    var _b = (0, react_1.useState)(false), addPresentationModalShown = _b[0], setAddPresentationModalShown = _b[1];
    var _c = (0, react_1.useState)(false), addEventModalShown = _c[0], setAddEventModalShown = _c[1];
    var _d = (0, react_1.useState)(false), addMetadataModalShown = _d[0], setAddMetadataModalShown = _d[1];
    var _e = (0, react_1.useState)(null), selectedPlayer = _e[0], setSelectedPlayer = _e[1];
    var _f = (0, react_1.useState)("player-details"), active = _f[0], setActive = _f[1];
    var _g = (0, react_1.useState)([]), bulkActionPlayerIds = _g[0], setBulkActionPlayerIds = _g[1];
    var _h = (0, react_1.useState)(false), confirmationModalOpened = _h[0], setConfirmationModalOpened = _h[1];
    var _j = (0, react_1.useState)(false), deleteMultipleConfirmationModalOpened = _j[0], setDeleteMultipleConfirmationModalOpened = _j[1];
    var _k = (0, react_1.useState)(false), resourceAccessModalShown = _k[0], setResourceAccessModalShown = _k[1];
    var _l = (0, react_1.useState)(null), currentGroupId = _l[0], setCurrentGroupId = _l[1];
    var _m = (0, react_1.useState)(null), currentPlayerId = _m[0], setCurrentPlayerId = _m[1];
    var _o = (0, react_1.useState)(), type = _o[0], setType = _o[1];
    var _p = (0, react_1.useState)(""), resourceName = _p[0], setResourceName = _p[1];
    var _q = (0, react_1.useState)(false), playerDeleteErrorModalShown = _q[0], setPlayerDeleteErrorModalShown = _q[1];
    var _r = (0, react_1.useState)({}), playerDeleteErrorResponse = _r[0], setPlayerDeleteErrorResponse = _r[1];
    var directPlayerPermissionResourceType = types_1.ResourceType.PLAYER.toLowerCase() + "s";
    var closeResourceAccessModal = function () { return setResourceAccessModalShown(false); };
    var toggleConfirmationModal = function () {
        setConfirmationModalOpened(function (prevState) { return !prevState; });
        setPlayerDetailsModalShown(function (prevState) { return !prevState; });
    };
    var toggleDeleteMultipleConfirmationModal = function () {
        setDeleteMultipleConfirmationModalOpened(function (prevState) { return !prevState; });
    };
    var deleteSinglePlayer = function (playerId) { return __awaiter(void 0, void 0, void 0, function () {
        var resourceId, response, _a, players_and_presentation_details, players_and_event_details, hasPresentations, hasEvents, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resourceId = isNaN(playerId) ? selectedPlayer.id : playerId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.deletePlayer(resourceId)];
                case 2:
                    response = _b.sent();
                    if (response.data.error) {
                        _a = response.data.data, players_and_presentation_details = _a.players_and_presentation_details, players_and_event_details = _a.players_and_event_details;
                        hasPresentations = players_and_presentation_details && players_and_presentation_details.length > 0;
                        hasEvents = players_and_event_details && players_and_event_details.length > 0;
                        if (hasPresentations || hasEvents) {
                            setPlayerDeleteErrorResponse({
                                message: response.data.error,
                                data: __spreadArray(__spreadArray([], (players_and_presentation_details || []).map(function (detail) { return (__assign(__assign({}, detail), { resource_type: "PRESENTATION" })); }), true), (players_and_event_details || []).map(function (detail) { return (__assign(__assign({}, detail), { resource_type: "EVENT" })); }), true)
                            });
                            setPlayerDeleteErrorModalShown(true);
                            return [2 /*return*/];
                        }
                    }
                    else {
                        setPlayerDeleteErrorResponse({});
                        setPlayerDeleteErrorModalShown(false);
                        refresh();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    logger.error("Failed to delete player", error_1);
                    setPlayerDeleteErrorModalShown(true);
                    return [3 /*break*/, 4];
                case 4:
                    setConfirmationModalOpened(false);
                    setPlayerDetailsModalShown(false);
                    unselect([resourceId]);
                    return [2 /*return*/];
            }
        });
    }); };
    var closeDeletePlayerErrorModal = function () {
        setPlayerDeleteErrorResponse({});
        setPlayerDeleteErrorModalShown(false);
    };
    var togglePlayerDetailsModal = function () {
        setActive("player-details");
        setPlayerDetailsModalShown(function (shown) { return !shown; });
    };
    var toggleAddPresentations = function () {
        setPlayerDetailsModalShown(function (shown) { return !shown; });
        setAddPresentationModalShown(function (shown) { return !shown; });
    };
    var toggleAddEvents = function () {
        setPlayerDetailsModalShown(false);
        setAddEventModalShown(function (shown) { return !shown; });
    };
    var toggleAddMetadata = function () {
        setPlayerDetailsModalShown(function (shown) { return !shown; });
        setAddMetadataModalShown(function (shown) { return !shown; });
    };
    (0, react_1.useEffect)(function () {
        if (addPresentationModalShown) {
            setPlayerDetailsModalShown(false);
        }
    }, [addPresentationModalShown]);
    var deleteMultiplePlayers = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (bulkActionPlayerIds.length == 1) {
                setSelectedPlayer({ id: bulkActionPlayerIds[0] });
                deleteSinglePlayer(bulkActionPlayerIds[0]);
            }
            else {
                bulkActionPlayerIds.forEach(function (playerId) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, ApiManager_1.default.deletePlayer(playerId)];
                            case 1:
                                _a.sent();
                                refresh();
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
            unselect(bulkActionPlayerIds);
            setDeleteMultipleConfirmationModalOpened(false);
            return [2 /*return*/];
        });
    }); };
    var onBulkActionHandler = function (command) {
        bulkActionPlayerIds.forEach(function (playerId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.toggleCommand(command, playerId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        refresh();
        unselect(bulkActionPlayerIds);
    };
    var openResourceAccessModal = function (resourceId, resourceName, type) {
        setType(type);
        setResourceName(resourceName);
        setResourceAccessModalShown(true);
        if (type === "Group") {
            setCurrentGroupId(resourceId);
        }
        else if (type === "Resource") {
            setCurrentPlayerId(resourceId);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.activeView === "list" ? (react_1.default.createElement(PlayersListView_1.default, { playerGroups: playerGroups, refreshPlayerGroups: refreshPlayerGroups, permissions: props.permissions, toggleDeleteMultipleConfirmationModal: toggleDeleteMultipleConfirmationModal, deleteSinglePlayer: deleteSinglePlayer, togglePlayerDetailsModal: togglePlayerDetailsModal, toggleAddPresentations: toggleAddPresentations, toggleAddEvents: toggleAddEvents, onBulkActionHandler: onBulkActionHandler, openResourceAccessModal: openResourceAccessModal, addPresentationModalShown: addPresentationModalShown, bulkActionPlayerIds: bulkActionPlayerIds, currentPlayerId: currentPlayerId, type: type, setBulkActionPlayerIds: setBulkActionPlayerIds, setConfirmationModalOpened: setConfirmationModalOpened, setPlayerDetailsModalShown: setPlayerDetailsModalShown, setCurrentGroupId: setCurrentGroupId, setSelectedPlayer: setSelectedPlayer, setResourceName: setResourceName })) : props.activeView === "overview" ? (react_1.default.createElement(PlayersOverviewList_1.default, { playerGroups: playerGroups, refreshPlayerGroups: refreshPlayerGroups, permissions: props.permissions, toggleDeleteMultipleConfirmationModal: toggleDeleteMultipleConfirmationModal, deleteSinglePlayer: deleteSinglePlayer, togglePlayerDetailsModal: togglePlayerDetailsModal, toggleAddPresentations: toggleAddPresentations, toggleAddEvents: toggleAddEvents, onBulkActionHandler: onBulkActionHandler, openResourceAccessModal: openResourceAccessModal, addPresentationModalShown: addPresentationModalShown, bulkActionPlayerIds: bulkActionPlayerIds, currentPlayerId: currentPlayerId, type: type, setBulkActionPlayerIds: setBulkActionPlayerIds, setConfirmationModalOpened: setConfirmationModalOpened, setPlayerDetailsModalShown: setPlayerDetailsModalShown, setCurrentGroupId: setCurrentGroupId, setSelectedPlayer: setSelectedPlayer, setResourceName: setResourceName })) : null,
        react_1.default.createElement(PlayerDetailsModal_1.default, { isShown: playerDetailsModalShown, toggle: togglePlayerDetailsModal, player: selectedPlayer, active: active, setActiveProp: setActive, toggleAddPresentations: toggleAddPresentations, toggleAddEvents: function () { return toggleAddEvents(); }, toggleAddMetadata: toggleAddMetadata, toggleConfirmationModal: toggleConfirmationModal, confirmationModalOpened: confirmationModalOpened, permissions: permissions, resourceType: directPlayerPermissionResourceType }),
        react_1.default.createElement(AddPresentationModal_1.default, { isShown: addPresentationModalShown, toggle: toggleAddPresentations, player: selectedPlayer, active: active, setActiveProp: setActive, type: types_1.ResourceType.PLAYER }),
        react_1.default.createElement(AddEventModal_1.default, { isShown: addEventModalShown, toggle: function () { return toggleAddEvents(); }, players: selectedPlayer ? [selectedPlayer] : bulkActionPlayerIds.map(function (id) { return ({ id: id }); }), setPlayerDetailsModalShown: setPlayerDetailsModalShown, bulkAction: !selectedPlayer }),
        react_1.default.createElement(AddMetadataModal_1.default, { isShown: addMetadataModalShown, toggle: toggleAddMetadata, player: selectedPlayer, setPlayerDetailsModalShown: setPlayerDetailsModalShown }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: toggleConfirmationModal, onConfirm: deleteSinglePlayer, onCancel: toggleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal //modal for deleting multiple players through list
        , { isShown: deleteMultipleConfirmationModalOpened, onClose: toggleDeleteMultipleConfirmationModal, onConfirm: deleteMultiplePlayers, onCancel: toggleDeleteMultipleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure? (This will not delete players with presentations)"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true }),
        react_1.default.createElement(ResourceAccessModal_1.default, { isShown: resourceAccessModalShown, onClose: closeResourceAccessModal, resourceType: types_1.ResourceType.PLAYER, type: type, resourceName: resourceName, groupId: currentGroupId, resourceId: currentPlayerId }),
        react_1.default.createElement(PlayerDeleteErrorModal_1.default, { isShown: playerDeleteErrorModalShown, onClose: closeDeletePlayerErrorModal, message: playerDeleteErrorResponse.message, data: playerDeleteErrorResponse.data, resourceId: selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id, deleteResourceMethod: deleteSinglePlayer })));
};
exports.default = PlayersListBase;
